module.exports = __webpack_public_path__ + "assets/img/italian_meringue_active.aa788f9e.png";